import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from "react";
import {createRoot} from "react-dom/client";

import App from "./App";
import {Auth0Provider} from "@auth0/auth0-react";
import {BrowserRouter as Router} from "react-router-dom";


const container = document.getElementById('root');

// Create a root. React 18
const root = createRoot(container);

// Auth0Provider allows us to use auth0 in our app for authentication.
root.render(<Auth0Provider domain={process.env.REACT_APP_AUTH0_DOMAIN}
                           clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
                           redirectUri={window.location.origin}
                           audience={process.env.REACT_APP_AUTH0_AUDIENCE}>
    <Router>
        <App/>
    </Router>
</Auth0Provider>);

